import { useEffect, useState, useCallback } from 'react'
import qs from 'qs'
import request from '../../utils/request'

function tf(str) {
  const re = /_(\w)/g
  const _str = str.replace(re, ($0, $1) => {
    return $1.toUpperCase()
  })
  return _str
}

export default (option = {}, deps = []) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const versionEnum = {
    150001: '基础版',
    150002: '专业版'
  }

  const valueEnum = {
    meinianBlogLimit: 'meinianBlogNum',
    meinianDownloadBlogLimit: 'meinianDownloadBlogNum',
    meinianInspirationChildLimit: 'meinianInspirationChildNum',
    meinianInspirationLimit: 'meinianInspirationNum',
    meinianIntelligenceTagLimit: 'meinianIntelligenceTagNum',
    meinianReportExportLimit: 'meinianReportExportNum',
  }
  const [authMeal, setAuthMeal] = useState({})
  const [update, setUpdate] = useState({})
  useEffect(() => {
    if (!query.shareUrl) { // 单独处理分享页
      fetchData()
    }
  }, [...deps, update])

  const fetchData = async () => {
    const result = await request.get('/zhikuan/ins/inspiration/auth/get-meal-auth', { params: { inspirationId: option?.inspirationId } })
    if (result) {
      setAuthMeal(result)
    }
  }
  const isAuthVersion = (code) => {
    return authMeal.skuId === code
  }

  const isAuthLimit = (code, extLimit = 0) => {
    const _code = tf(code)
    if (authMeal[_code] === undefined || authMeal[valueEnum[_code]] === undefined) {
      return true
    }
    if (authMeal[_code] === 0 && !authMeal[_code]) {
      return true
    }
    if (authMeal[valueEnum[_code]] < authMeal[_code] + extLimit) {
      return true
    }
    return false
  }

  const isRealTimeAuthLimit = async (code, extLimit = 0) => {
    const result = await request.get('/zhikuan/ins/inspiration/auth/get-meal-auth', { params: { inspirationId: option?.inspirationId } })
    if (result) {
      const _code = tf(code)
      if (result[_code] === undefined || result[valueEnum[_code]] === undefined) {
        return true
      }
      if (result[_code] === 0 && !result[_code]) {
        return true
      }
      if (result[valueEnum[_code]] < result[_code] + extLimit) {
        return true
      }
      return false
    }
  }

  const isFreezeStatus = () => {
    if (authMeal.meinianInspirationNormalNum > authMeal.meinianInspirationLimit || authMeal.meinianInspirationProNum > 0) {
      return true
    }
    return false
  }

  const onUpdate = useCallback(() => {
    setUpdate({})
  }, [])

  return {
    authMeal,
    versionId: authMeal.skuId,
    versionName: versionEnum[authMeal.skuId],
    isAuthVersion,
    isAuthLimit,
    isRealTimeAuthLimit,
    onUpdate,
    isFreezeStatus,
  }
}
